import { __awaiter, __generator } from "tslib";
import { createButtonDriver, createCheckboxDriver } from '../../drivers';
import { popoverDriver } from '../../primitives/popover/driver';
import { compKey } from './key';
export var createLocalesPickerDriver = function (wrapper, global) {
    var base = wrapper.$("." + compKey);
    var popover = popoverDriver(global);
    return {
        getPickedLocales: function () { return base.$('.picked-locales').attr('data-value'); },
        openPicker: createButtonDriver(base, 0).click,
        isLocaleEnabledAtIndex: function (idx) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, createCheckboxDriver(popover.$(".locales-checkboxes"), idx).value()];
        }); }); },
        toggleLocaleAtIndex: function (idx) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, createCheckboxDriver(popover.$(".locales-checkboxes"), idx).toggle()];
        }); }); },
        isApplyDisabled: function () { return createButtonDriver(popover.$('.locale-picker-footer'), 1).isDisabled(); },
        apply: function () { return createButtonDriver(popover.$('.locale-picker-footer'), 1).click(); },
        cancelChanges: function () { return createButtonDriver(popover.$('.locale-picker-footer'), 0).click(); },
        isAllLocalesEnabled: function () { return createCheckboxDriver(popover.$('.locales-menu-wrapper'), 0).value(); },
        toggleAllLocales: function () { return createCheckboxDriver(popover.$('.locales-menu-wrapper'), 0).toggle(); },
        clickAllLocales: function () { return createCheckboxDriver(popover.$('.locales-menu-wrapper'), 0).base.$('.checkbox-body').click(); },
        isLocalesMenuOpen: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, popover.$(".locales-menu-wrapper").exists()];
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map